module.exports = __webpack_public_path__ + "img/icon-arrow-down@2x.815130f7.png";